import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Users, Pill, ClipboardList, Bell, LogOut, UserCog, Link2, BarChart2, ShoppingCart, Award } from "lucide-react";

const NAV = [
  { to: "/admin",               label: "Dashboard",      Icon: LayoutDashboard, end: true },
  { to: "/admin/clientes",      label: "Clientes",       Icon: Users },
  { to: "/admin/medicamentos",  label: "Medicamentos",   Icon: Pill },
  { to: "/admin/inscripciones", label: "Inscripciones",  Icon: ClipboardList },
  { to: "/admin/notificaciones",label: "Notificaciones", Icon: Bell },
  { to: "/admin/reportes",      label: "Reportes",       Icon: BarChart2 },
  { to: "/admin/vip",           label: "Lealtad VIP",    Icon: Award },
  { to: "/admin/erp",           label: "Config ERP",     Icon: Link2 },
  { to: "/admin/usuarios",      label: "Usuarios",       Icon: UserCog },
];

export default function Layout({ onLogout }) {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen bg-slate-50">
      <aside className="w-60 bg-white border-r border-slate-200 flex flex-col shadow-sm">
        {/* Logo */}
        <div className="p-5 border-b border-slate-100 flex items-center gap-3">
          <img src="/logo-farmavida2.jpg" alt="Farmavida" className="w-9 h-9 rounded-lg object-cover" />
          <div>
            <p className="text-sm font-bold text-slate-800 leading-tight">Farmavida</p>
            <p className="text-xs text-slate-400">Ahorra con Nosotros</p>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex-1 p-3 space-y-0.5">
          {NAV.map(({ to, label, Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive
                    ? "bg-red-50 text-red-700 font-semibold"
                    : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className={`w-4 h-4 ${isActive ? "text-red-600" : "text-slate-400"}`} />
                  {label}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* POS Online — enlace externo */}
        <div className="px-3 pb-2">
          <a
            href="/pos/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors text-slate-600 hover:bg-slate-50 hover:text-slate-900"
          >
            <ShoppingCart className="w-4 h-4 text-slate-400" />
            POS Online
          </a>
        </div>

        {/* Logout */}
        <div className="p-3 border-t border-slate-100">
          <Button
            variant="ghost"
            size="sm"
            className="w-full justify-start gap-3 text-slate-500 hover:text-red-600 hover:bg-red-50"
            onClick={() => { onLogout(); navigate("/login"); }}
          >
            <LogOut className="w-4 h-4" />
            Cerrar sesión
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}
